module.exports = __webpack_public_path__ + "img/user.de3eb829.png";